import intercomMethod from './method';

export default function show() {
  intercomMethod('show');
}
